export default __webpack_public_path__ + "static/media/cartBg.bac241ae.png";